<template>
  <div>
    <div class="bg-banner" />
    <div id="login-box" :style="{maxWidth:device==='mobile'?'80%':'100%'}">
      <div v-if="device==='desktop'" class="login-banner" />
      <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="on" label-position="left">
        <div class="title-container">
          <h3 class="title">{{ title }}管理后台注册</h3>
        </div>
        <div>
          <el-form-item prop="account">
            <el-input ref="name" v-model="loginForm.username" placeholder="用户名" type="text" tabindex="1" auto-complete="on">
              <svg-icon slot="prefix" icon-class="user" />
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input ref="password" v-model="loginForm.password" :type="passwordType" placeholder="密码" tabindex="2" auto-complete="on" @keyup.enter.native="handleLogin">
              <svg-icon slot="prefix" icon-class="password" />
              <span slot="suffix" @click="showPwd">
                <svg-icon :icon-class="passwordType === 'password' ? 'eye' : 'eye-open'" />
              </span>
            </el-input>
          </el-form-item>
        </div>
        <el-button :loading="loading" type="primary" style="width: 100%;" @click.native.prevent="handleLogin">登 录</el-button>
      </el-form>
    </div>
    <Copyright />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ResizeMixin from '@/layout/mixin/ResizeHandler'
import Copyright from '@/layout/components/Copyright'
import api from '@/api/configure'
export default {
  name: 'Login',
  components: { Copyright },
  mixins: [ResizeMixin],
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      loginForm: {
        username: '',
        password: ''
      },
      loginRules: {
        username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      passwordType: 'password',
      loading: false,
      redirect: undefined
    }
  },
  computed: {
    ...mapState({
      device: state => state.app.device
    })
  },
  watch: {
    $route: {
      handler: function(route) {
        this.redirect = route.query && route.query.redirect
      },
      immediate: true
    }
  },
  mounted() {
    this.fetchData()
    // if (this.loginForm.username === '') {
    //   this.$refs.username.focus()
    // } else if (this.loginForm.password === '') {
    //   this.$refs.password.focus()
    // }
  },
  destroyed() {
    // window.removeEventListener('storage', this.afterQRScan)
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      // this.$nextTick(() => {
      //   this.$refs.password.focus()
      // })
    },
    handleLogin() {
      this.$refs.loginForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('user/login', this.loginForm)
            .then(() => {
              this.$router.push({ path: this.redirect || '/' })
              this.loading = false
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    fetchData() {
      api.Get({ field: 'website_name' }).then(response => {
        if (response.data != null) {
          this.title = response.data.website_name
        }
      })
    }
  }
}
</script>

  <style lang="scss" scoped>
  @import "~@/styles/mixin.scss";
  /deep/ input[type=password]::-ms-reveal {
      display: none;
  }
  .bg-banner {
      position: absolute;
      z-index: 0;
      width: 100%;
      height: 100%;
      background-image: url(../../assets/images/login-bg.jpg);
      background-size: cover;
      background-position: center center;
  }
  #login-box {
      display: flex;
      justify-content: space-between;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      background: rgba(255, 255, 255, 0.8);
      border-radius: 10px;
      overflow: hidden;
      box-shadow: 0 0 5px #999;
      .login-banner {
          width: 300px;
          background-image: url(../../assets/images/login-banner.jpg);
          background-size: cover;
          background-position: center center;
      }
      .login-form {
          width: 450px;
          padding: 50px 35px 30px;
          overflow: hidden;
          .svg-icon {
              vertical-align: -0.35em;
          }
          .title-container {
              position: relative;
              .title {
                  font-size: 22px;
                  color: #666;
                  margin: 0 auto 30px;
                  text-align: center;
                  font-weight: bold;
                  @include text-overflow;
              }
          }
      }
      /deep/ .el-input {
          display: inline-block;
          height: 48px;
          width: 100%;
          input {
              height: 48px;
          }
          .el-input__prefix {
              left: 10px;
          }
          .el-input__suffix {
              right: 10px;
          }
      }
      .el-checkbox {
          margin: 20px 0;
      }
  }
  .copyright {
      position: absolute;
      bottom: 30px;
      width: 100%;
      margin: 0;
      mix-blend-mode: difference;
  }
  </style>
